import { render } from "./card-content.vue?vue&type=template&id=06a9aabe&scoped=true"
import script from "./card-content.vue?vue&type=script&lang=js"
export * from "./card-content.vue?vue&type=script&lang=js"

import "./card-content.vue?vue&type=style&index=0&id=06a9aabe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a9aabe"]])

export default __exports__